import { ComponentProps } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import useCreateUpsellRequest, {
  CreateProps as RequestProps,
} from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  requestDetail: RequestProps
  buttonLabel: string
  type?: ComponentProps<typeof Button>['type']
  onClick: () => void
}

const RequestInfoButton = ({ requestDetail, type = 'upgrade', buttonLabel, onClick }: Props) => {
  const { create, loading } = useCreateUpsellRequest()

  const upsellOnClick = async () => {
    await create(requestDetail)
    onClick()
  }

  return (
    <Box alignItems="center">
      <Button type={type} loading={loading} onClick={upsellOnClick}>
        {buttonLabel}
      </Button>
    </Box>
  )
}

export default RequestInfoButton
